import { SxProps } from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import { ONTOLOGIES } from "core/model/utils/ontologies";
import { RADIO_WHITE_BACKGROUND } from "ds_legacy/materials/colors";
import { padding, sizing } from "ds_legacy/materials/metrics";
import {
  PatientFormSubheading,
  Section,
} from "dsl/ecosystems/PatientForms/components";
import { OntologyRadioGroupV2 } from "dsl/molecules/OntologyRadioGroup";
import { useTranslations } from "translations";

export const SectionFive = () => {
  const translations = useTranslations();

  return (
    <Section title={translations.patientForms.drvGeneralForm.sectionFour.title}>
      <PatientFormSubheading style={{ padding: padding(0, 0, 1) }}>
        {translations.patientForms.drvGeneralForm.sectionFour.subtitle}
      </PatientFormSubheading>
      <OntologyRadioGroupV2
        elementName="employment_status"
        formControlLabelSx={{ marginLeft: 0, paddingBottom: sizing(0.5) }}
        formLabelSx={visuallyHidden as SxProps}
        label={translations.patientForms.drvGeneralForm.sectionFour.subtitle}
        radioSx={RADIO_WHITE_BACKGROUND}
        type={ONTOLOGIES.EMPLOYMENT_STATUS}
      />
    </Section>
  );
};
